import React from "react";

export const GrainOverlay = () => (
  <>
    <div className="grain-fixed" aria-hidden="true" />
    <div className="vignette" aria-hidden="true" />
  </>
);

export default GrainOverlay;
